import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";
import {TAction, TBlendedTipo} from "../../../app/enum";
import {CONFIG} from "../../../app/config";

import {LogadoService} from "../../../providers/logado-service";
import {EntrakiService} from "../../../providers/entraki-service";
import {TFilterOpera} from '../../../pipes/filter-field/filter-field';
import {TConviteSeta} from '../../../components/app-convite/app-convite';
import {WebstorService} from '../../../providers/webstor-service';
import {HotspotService} from '../../../providers/hotspot-service';
import {SpotdayService} from '../../../providers/spotday-service';
import {ModalActionPage} from '../modal-action/modal-action';
import {SpotdayListPage} from '../spotday-list/spotday-list';
import {SpotdayInfoPage} from '../spotday-info/spotday-info';

@Component({
    selector: 'page-convite-menu',
    templateUrl: 'convite-menu.html',
    providers: [WebstorService, EntrakiService, HotspotService, SpotdayService]
})
export class ConviteMenuPage {

    TConviteSeta: any = TConviteSeta;
    TFilterOpera: any = TFilterOpera;
    
    config: any;
    logado: any;

    etapa: number;
    userset: any;

    rootspot: any;
    recintos: any;

    convites: any [];
    copyites: any [];

    blendeds: any [];
    
    entradaPage: number = -1;
    entradaSexo: boolean;
    entradaLoop: any[];
    
    produtoID: number;
    entradaDual: any;
    convitePage: number = -1;
    conviteSexo: any;
    conviteKing: 'Ingresso' | 'Camarote' | 'Flyer';

    spotdayLoad: any;

    constructor(public navParams: NavParams, public viewCtrl: ViewController, public util: Util,
                public navCtrl: NavController,
                public logadoService: LogadoService,
                public entrakiService: EntrakiService,
                public webstorService: WebstorService,
                public hotspotService: HotspotService,
                public spotdayService: SpotdayService) {

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Entraki', '/entraki-open');

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.rootspot = this.navParams.get('rootspot');
        this.recintos = this.navParams.get('recintos');
        this.userset = this.navParams.get('userset');


        if (this.etapa == 0) {

            this.conviteKing = 'Ingresso';
            this.recintoLoad();

        }

        if (this.etapa == 1) {

            this.convites = this.navParams.get('convites');
            this.copyites = this.navParams.get('copyites');
            this.spotdayLoad = this.navParams.get('spotdayLoad');
            this.entradaPage = this.navParams.get('entradaPage');
            this.entradaSexo = this.navParams.get('entradaSexo');

            this.produtoID = this.navParams.get('produtoID');
            this.convitePage = (this.convitePega(this.produtoID)[0].Produto.ProdutoLote == 0 ? 1 : -1);

            this.segmentLote(1, true);
            this.segmentLote(0, true);
            this.conviteDual(null);
            this.conviteBlur('lote');

        }


    }


    ionViewWillEnter() {

    }

    ionViewDidEnter() {

    }

    statusbar() {

        let style = this.util.stylesBarColor('CorDark');
        this.util.statusBarColor(style);

    }

    getTitle() {

        if (this.etapa == 0) return 'Portaria';

    }

    prepareLoop(convites) {
        
        if (!convites) return;

        this.entradaSexo = (convites.filter(CV => CV.ConviteSexo == 1).length > 0);
        let loteriaQtde = this.util.jsMax(convites, ['Produto', 'ProdutoLote']);
        
        this.entradaLoop = [];
        for (let i = 1; i <= loteriaQtde; i++) {
            let array = convites.filter(CV => CV.Produto.ProdutoLote == i);
            let loteriaInfo = {LoteriaLote: i, Convites: array};
            this.entradaLoop.push(loteriaInfo);
        }
        
    }

    recintoLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.recinto(TAction.acLoad, 0, this.rootspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    
                    this.recintos = data.Recintos;

                    if (this.recintos.length == 1) {
                        this.entradaPage = 0;
                        this.conviteLoad();
                    }                            

                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    recintoCoin(index) {

        let onOkey = (okey, that, data) => {

            that.dismiss();

            let qtde = parseInt(this.util.currency(okey.inputf.text)+'');
            let arry = this.recintos[this.entradaPage].RecintoLoja.split(',');

            if (qtde != null && qtde >= 1) {
                if (arry.length < index-1)  arry.push(qtde);    //Adiciona
                if (arry.length >= index-1) arry[index] = qtde; //Troca
            }

            let recintoCate = arry.join(',');
            this.recintoLoja(recintoCate);
        };

        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'servico', onOkey, null, false, 'Antecipado')};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    recintoCash(index) {

        let ipos = 0;
        let arry = this.recintos[this.entradaPage].RecintoLoja.split(',');
        if (arry.length >= index) ipos = arry[index] / 5;

        let onSave = (qtde) => {
            if (qtde == null) {
                this.recintoCoin(index);
                return;
            }

            if (qtde != null && qtde == 0) arry.splice(index, 1);
            if (qtde != null && qtde >= 1) {
                if (arry.length < index-1)  arry.push(qtde);    //Adiciona
                if (arry.length >= index-1) arry[index] = qtde; //Troca
            }
            
            let recintoCate = arry.join(',');
            this.recintoLoja(recintoCate);
        }

        let buttons: Array<any> = [];
        buttons.push({text: 'Excluir', value: 0});
        for (let i = 5; i <= 100; i = i + 5) {
            buttons.push({text: 'R$ ' + i, value: i});
        }
        buttons.push({text: 'Digitar', value: null});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = ipos;
        this.util.pickerOpen(columns, onSave);

    }

    recintoLoja(recintoCate) {

        let recinto = this.util.deepCopy(this.recintos[this.entradaPage]);
        recinto.RecintoLoja = recintoCate;

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.recinto(TAction.acLoja, 0, this.rootspot.Hotspots[0].HotspotID, this.recintos[this.entradaPage].RecintoID, recinto)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.recintos[this.entradaPage].RecintoLoja = recintoCate,
                erro => this.util.alertResult(erro)
            );

    }

    conviteLoad() {

        this.convites = null;
        this.copyites = null;
        if (this.entradaPage < 0) return;

        let spotdayID = (this.spotdayLoad ? this.spotdayLoad.SpotdayID : 0);
        let ambientID = this.recintos[this.entradaPage].Ambient.AmbientID;


        let loading = this.util.loadingDots();
        loading.present();

        this.entrakiService.convite(TAction.acLoad, this.rootspot.Hotspots[0].HotspotID, spotdayID, ambientID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {


                    //PREPARE
                    data.Convites.forEach(conviteSexo => {
                        let conviteTurn = this.rootspot.Hotspots[0].HotspotTurn;
                        let conviteHora = (conviteSexo.ConviteHora == conviteTurn ? 0 : (conviteSexo.ConviteHora + (conviteSexo.ConviteHora < conviteTurn ? (24 - conviteTurn) : 0)));
                        conviteSexo._hora = conviteHora;
    
                        this.conviteSexo = conviteSexo;
                        this.conviteBlur('seco');
                    });


                    //PREPARE
                    this.prepareLoop(data.Convites);


                    //DEFINE
                    this.convites = data.Convites;
                    this.copyites = this.util.deepCopy(data.Convites);

                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                });

    }

    spotdayEdit(spotday) {

        let object = {etapa: 0, spotdayID: 0, spotday: spotday, rootspot: this.rootspot, userset: this.userset};
        this.util.modalopen(SpotdayInfoPage, 'alto', false, object).subscribe(data => this.spotdayTela(data));

    }
    
    spotdayList() {

        let object = {etapa: 0, flagstor: true, spotdayID: 0, rootspot: this.rootspot, userset: this.userset, rootile: this.logado};
        this.util.modalopen(SpotdayListPage, 'alto', false, object).subscribe(data => this.spotdayTela(data));

    }

    spotdayTela(spotday) {

        this.spotdayLoad = spotday;
        this.entradaPage = -1;
        this.conviteKing = 'Ingresso';//(spotday ? 'Flyer' : 'Ingresso');

    }

    spotdaySeta() { 

        let loading = this.util.loadingDots();
        loading.present();

        this.spotdayService.spotday(TAction.acList, 0, this.rootspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let buttons: Array<any> = [];
                    buttons.push({text: 'Hoje', handler: () => this.spotdayTela(null)});
                    data.Spotdays.forEach(SD => buttons.push({text: this.util.semana(SD.SpotdayDate, true) + ' - ' + this.util.dataft(SD.SpotdayDate, 'dd', 'char', null, '/') + ' - ' + SD.Projeto.ProjetoNome, handler: () => this.spotdayTela(SD)}))
                    buttons.push({text: 'Antigos', handler: () => this.spotdayList()});
                    this.util.sheetOpen(buttons, 'SPOTDAY', 0);
            
                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                });

    }

    conviteView() {

        let buttons: Array<any> = [];
        buttons.push({text: 'Ingresso', handler: () => this.conviteKing = 'Ingresso'});
        buttons.push({text: 'Camarote', handler: () => this.conviteKing = 'Camarote'});
        this.util.sheetOpen(buttons, 'CONVITE', 0);

    }

    conviteSeta(conviteSeta: TConviteSeta) {

        this.util.impact();
        this.conviteSexo.conviteSeta = conviteSeta;

    }

    convitePega(produtoID: number): any[] {
                
        return this.copyites.filter(CV => CV.Produto.ProdutoID == produtoID);
        
    }

    segmentLote(convitePage: number, force: boolean) {

        if (convitePage == -1) convitePage = 0;

        let array = this.convitePega(this.produtoID);
        
        this.conviteSexo = array[convitePage];
        if (!this.conviteSexo) return;

        this.conviteDual(null);

        if (!force && this.conviteSexo.conviteSeta >= TConviteSeta.csFree) return;

        let code = this.conviteSexo.ConviteID;
        let seco = this.conviteSexo.ConviteSeco;
        let suma = this.conviteSexo.ConviteSuma;
        if (seco+suma == 0 && !code) this.conviteSexo.conviteSeta = TConviteSeta.csNone;
        if (seco+suma == 0 &&  code) this.conviteSexo.conviteSeta = TConviteSeta.csFree;
        if (seco != 0)               this.conviteSexo.conviteSeta = TConviteSeta.csSeco;
        if (suma != 0)               this.conviteSexo.conviteSeta = TConviteSeta.csSuma;
        
    }

    unisexoInit(entradaSexo: boolean) {

        this.entradaSexo = entradaSexo;
        this.conviteCria();

    }

    conviteCria() {

        let onLoad = (blendeds) => {

            this.blendeds = blendeds;

            /** OPEN **/
            let buttons: Array<any> = [];

            //ctConvite
            let conviteLote = this.util.jsMax(this.copyites, ['Produto', 'ProdutoLote']) + 1;
            this.blendeds.forEach(BL => {
                BL.Produtos.forEach(PD => {

                    if ((this.copyites.length && !PD.ProdutoLote) || (PD.ProdutoLote == conviteLote)) {
                        let exist = this.copyites.filter(CV => CV.Produto.ProdutoID == PD.ProdutoID)[0];
                        if (!exist) buttons.push({text: PD.ProdutoNome, handler: () => this.conviteOpen(PD)});
                    }
        
                });
            });

            //ctCertify
            let meritum = this.rootspot.Meritums[0];
            if (meritum && meritum.BlendedArray[0])
            meritum.BlendedArray[0].ProdutoCards.forEach(card => {
                let exist = this.copyites.filter(CV => CV.Produto.ProdutoID == card.ProdutoID)[0];
                if (!exist) buttons.push({text: card.ProdutoNome, handler: () => this.conviteOpen(card)});
            });
                
            this.util.sheetOpen(buttons, 'CONVITE', 0);


        }

        // Já esta carregado
        if (this.blendeds) {
            onLoad(this.blendeds);
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.blended(TAction.acTipo, 0, TBlendedTipo.btConvite)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data.Blendeds),
                erro => this.util.alertResult(erro, () => this.dismiss())
            )

    }

    conviteMenu(convite: any) {

        
        let onEdit = () => {

            this.conviteOpen(convite.Produto);

        }
        
        let maximo = this.util.jsMax(this.convites, ['Produto', 'ProdutoLote']);
        let exclui = (convite && (convite.Produto.ProdutoLote == 0 || convite.Produto.ProdutoLote == maximo));
        let altera = convite;


        /** OPEN **/
        let buttons: Array<any> = [];
        if (!altera) buttons.push({text: 'Incluir', handler: () => this.conviteCria()});
        if ( altera) buttons.push({text: 'Alterar', handler: () => onEdit()});
        if ( exclui) buttons.push({text: 'Excluir', handler: () => this.conviteLixo(convite.Produto.ProdutoID), role: 'destructive'});
        this.util.sheetOpen(buttons, 'LOTE');

    }

    conviteMaxi(real: number, lote: boolean): number {

        let rage = (lote ? 10000 : 20000);
        if (real < 6000        ) rage = 6000;
        if (real < 4000        ) rage = 4000;
        if (real < 2000        ) rage = 2500;
        if (real < 1200        ) rage = 1200;
        if (real < 600         ) rage = 600;
        if (real < 300 && !lote) rage = 300;
        if (real < 100 && !lote) rage = 100;
        
        return rage;

    }

    conviteBool(convite) {

        return (convite.ConviteDoor || convite.ConviteList || convite.ConviteSale);

    }

    conviteText(onesex: boolean, rowline, tipo: 'nome' | 'info') {

        let turnday = this.rootspot.Hotspots[0].HotspotTurn;
        let rowqtde = this.util.numerico(rowline.ConviteQtde);
        let rowhora = rowline.ConviteHora;
        let rowtime = rowline.ConviteHora + 'h' + (rowline.ConviteHour ? '30' : '00');
        let rowuser = (rowline.ConviteList || rowline.ConviteSale);
      //let enabled = (rowline.ConviteDoor || rowline.ConviteList || rowline.ConviteSale);

        if (tipo == 'nome') {
            if (rowline.Produto.ProdutoLote == 0) return rowline.Produto.ProdutoNome;
            if (rowline.ConviteDoor) return 'Porta' + (rowuser ? (turnday == rowhora ? ' sempre' : ' ' + rowtime) : '');
            if (rowline.ConviteList && rowline.ConviteSale) return 'Online';
            if (rowline.ConviteList) return 'Lista';
            if (rowline.ConviteSale) return 'Venda';
        }

        if (tipo == 'info') {
            let text = (rowline.ConviteList ? 'Lista' : 'Venda');
            if (!rowuser &&  rowline.ConviteDoor && rowline.ConviteHora == turnday) return (onesex ? 'nunca expira' : 'sempre');
            if (!rowuser &&  rowline.ConviteDoor) return (onesex ? 'até ' : '') + rowtime;
            if ( rowuser && !rowline.ConviteQtde) return (!rowline.ConviteDoor ? '' : text + ' ') + 'sempre';
            if ( rowuser &&  rowline.ConviteQtde) return (onesex || !rowline.ConviteDoor ? '' : text + ' ') + rowqtde + (onesex ? ' pessoas' : '');
        }
         
        return '';

    }

    conviteHora($event) {
                
        let hora = $event.value;
        let turn = this.rootspot.Hotspots[0].HotspotTurn;
        let calc = hora + turn;
        
        hora = (turn ? (calc > 23 ? calc - 24 : calc) : hora);

        let array = this.convitePega(this.produtoID);
        array.forEach(CV => CV.ConviteHora = hora);

    }

    conviteStep(spin: 'seco' | 'suma' | 'suga' | 'king'): number {

      //if (spin == 'king') return this.conviteSexo._rage >= 1500 ? 100 : (this.conviteSexo._rage >= 1000 ? 50 : (this.conviteSexo._rage >= 100 ? 10 : 5));
        if (spin == 'seco') return this.conviteSexo._seco > 5000 ? 100 : (this.conviteSexo._seco > 300 ? 50 : (this.conviteSexo._seco > 100 ? 10 : 5));
        if (spin == 'suma') return this.conviteSexo._suma > 5000 ? 100 : (this.conviteSexo._suma > 300 ? 50 : (this.conviteSexo._suma > 100 ? 10 : 5));
        if (spin == 'suga') return this.conviteSexo.ConviteSuma > 5000 ? 100 : (this.conviteSexo.ConviteSuma > 300 ? 50 : (this.conviteSexo.ConviteSuma > 100 ? 10 : 5));

        return 0;
        
    }

    conviteHalf(main = 'SECO' || 'MAIS' || 'TIRA') {

        let soma = this.conviteSexo._seco > 300 ? 25 : (this.conviteSexo._seco > 100 ? 5 : 1);
        let novo = 0;

        if (main == 'SECO') {
            novo = this.conviteSexo.ConviteSeco + soma;
            if (novo >= this.conviteSexo._seco) return;
            this.conviteSexo.ConviteSeco = novo;
            return;
        }

        if (this.conviteSexo._meia) {
            if (main == 'TIRA') novo = this.conviteSexo.ConviteMeia + soma;
            if (main == 'MAIS') novo = this.conviteSexo.ConviteMeia - soma;
            if (!novo || novo >= this.conviteSexo.ConviteSeco) return;
            this.conviteSexo.ConviteMeia = novo;
        }

        if (this.conviteSexo._obar) {
            if (main == 'MAIS') novo = this.conviteSexo.ConviteObar + soma;
            if (main == 'TIRA') novo = this.conviteSexo.ConviteObar - soma;
            if (!novo || novo <=  this.conviteSexo.ConviteSeco) return;
            this.conviteSexo.ConviteObar = novo;
        }

    }

    openbarFlag(tipo : 'meia' | 'obar') {

        this.util.impact();

        let step = this.conviteStep('seco');

        if (tipo == 'meia') {
            let lower = (this.conviteSexo.ConviteSeco / 2);
            lower = lower - (lower % step);
            console.log(lower, (lower % step), (lower % step) == 0);
            this.conviteSexo._obar = false;
            this.entradaDual = this.conviteSexo._meia ? {upper: this.conviteSexo.ConviteSeco, lower: lower} : this.conviteSexo.ConviteSeco;
        }

        if (tipo == 'obar') {
            let upper = (this.conviteSexo.ConviteSeco * 1.5);
            upper = upper + (upper % step);
            this.conviteSexo._meia = false;
            this.entradaDual = this.conviteSexo._obar ? {upper: upper, lower: this.conviteSexo.ConviteSeco} : this.conviteSexo.ConviteSeco;
        }

        //this.conviteBlur('seco');
    }

    conviteDual(name: null | 'seco') {

        if (name == null) {
            
            this.conviteSexo._meia = (this.conviteSexo.ConviteMeia > 0);
            this.conviteSexo._obar = (this.conviteSexo.ConviteObar > 0);
            
            if (this.conviteSexo._meia) {
               this.entradaDual = {upper: this.conviteSexo.ConviteSeco, lower: this.conviteSexo.ConviteMeia}
               return;
            }
            
            if (this.conviteSexo._obar) {
               this.entradaDual = {upper: this.conviteSexo.ConviteObar, lower: this.conviteSexo.ConviteSeco}
               return;
            }

            this.entradaDual = this.conviteSexo.ConviteSeco;
            return;

        }


        if (name == 'seco') {

            if (this.conviteSexo._meia) {
                this.conviteSexo.ConviteSeco = this.entradaDual.upper;
                this.conviteSexo.ConviteMeia = this.entradaDual.lower;
                this.conviteSexo.ConviteObar = 0;
                return;
             }
             
             if (this.conviteSexo._obar) {
                this.conviteSexo.ConviteSeco = this.entradaDual.lower;
                this.conviteSexo.ConviteMeia = 0;
                this.conviteSexo.ConviteObar = this.entradaDual.upper;
                return;
            }
            
            if (!this.conviteSexo._meia && !this.conviteSexo._obar) {
                this.conviteSexo.ConviteSeco = this.entradaDual;
                this.conviteSexo.ConviteMeia = 0;
                this.conviteSexo.ConviteObar = 0;
               return;
            }
            
         }
 
    }

    conviteBlur(name: 'lote' | 'seco' | 'suma' | 'suga') {

        if (name == 'suma' && this.conviteSexo.ConviteSuma <  this.conviteSexo.ConviteSeco) this.conviteSexo.ConviteSuma = 0;
        if (name == 'suma' && this.conviteSexo.ConviteSuga >= this.conviteSexo.ConviteSuma) this.conviteSexo.ConviteSuga = 0;


        if (name == 'lote') {
            let array = this.convitePega(this.produtoID);
            let real = this.conviteMaxi(array[0].ConviteQtde, true);
            array.forEach(CV => CV._rage = real);
            this.conviteSexo._rage = real;
         }

        if (name == 'seco') {
           let real = (this.conviteSexo.ConviteObar ? this.conviteSexo.ConviteObar : this.conviteSexo.ConviteSeco);
           this.conviteSexo._seco = this.conviteMaxi(real, false);
        }

        if (name == 'seco' || name == 'suma') {
           let real = this.conviteSexo.ConviteSuma ? this.conviteSexo.ConviteSuma : this.conviteSexo.ConviteSeco;
           this.conviteSexo._suma = this.conviteMaxi(real, false);
        }

        if (name == 'suga' && this.conviteSexo.ConviteSuga >= this.conviteSexo.ConviteSuma) {
            this.conviteSexo.ConviteSuga = 0;
        }

    }

    conviteOpen(produto: any) {

        let clienteBool = (produto.ProdutoLote > 0);
        let conviteFind = this.convitePega(produto.ProdutoID);
        let entradaSexo = (clienteBool ? this.entradaSexo : false);

        if (conviteFind.length == 0) {

            let conviteRage = this.conviteMaxi(0, true);
            let conviteTurn = this.rootspot.Hotspots[0].HotspotTurn;
            let conviteZero = {ConviteID: 0, Produto: produto, ConviteDoor: false, ConviteList: false, ConviteSale: false, ConviteQtde: 0, ConviteHora: conviteTurn, ConviteHour: 0, ConviteSexo: 0, ConviteFree: false, ConviteMeia: 0, ConviteObar: 0, ConviteSeco: 0, ConviteSuma: 0, ConviteSuga: 0, _hora: 0, _rage: conviteRage};
            let conviteMale = {ConviteID: 0, Produto: produto, ConviteDoor: false, ConviteList: false, ConviteSale: false, ConviteQtde: 0, ConviteHora: conviteTurn, ConviteHour: 0, ConviteSexo: 1, ConviteFree: false, ConviteMeia: 0, ConviteObar: 0, ConviteSeco: 0, ConviteSuma: 0, ConviteSuga: 0, _hora: 0, _rage: conviteRage};
            let conviteFema = {ConviteID: 0, Produto: produto, ConviteDoor: false, ConviteList: false, ConviteSale: false, ConviteQtde: 0, ConviteHora: conviteTurn, ConviteHour: 0, ConviteSexo: 2, ConviteFree: false, ConviteMeia: 0, ConviteObar: 0, ConviteSeco: 0, ConviteSuma: 0, ConviteSuga: 0, _hora: 0, _rage: conviteRage};
                    
            let index = this.copyites.length;
            if (produto.ProdutoLote > 0) index = this.util.jsMax(this.copyites, ['Produto', 'ProdutoLote']);

            if (!entradaSexo) {
                this.copyites.splice(index, 0, conviteZero);
            }

            if ( entradaSexo) {
                this.copyites.splice(index,   0, conviteMale);
                this.copyites.splice(index+1, 0, conviteFema);
            }

        }

        let object = {etapa: 1, rootspot: this.rootspot, recintos: this.recintos, userset: this.userset, convites: this.convites, copyites: this.copyites, entradaPage: this.entradaPage, entradaSexo: entradaSexo, produtoID: produto.ProdutoID, spotdayLoad: this.spotdayLoad};
        this.util.modalopen(ConviteMenuPage, 'quad', true, object)
        .finally(() => this.prepareLoop(this.copyites))
        .subscribe(data => {
            if (data == '#CONVITE-LOAD#') {
                this.conviteLoad();
            }
        })

    }

    conviteLixo(produtoID) {
        
        let ambientID = this.recintos[this.entradaPage].Ambient.AmbientID;
        
        let array = this.convitePega(produtoID);
        let conviteJson = {Convites: array};
        
        let loading = this.util.loadingDots();
        loading.present();

        this.entrakiService.convite(TAction.acLixo, this.rootspot.Hotspots[0].HotspotID, 0, ambientID, conviteJson)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    array.forEach(CV => {

                        let index = this.copyites.indexOf(CV);
                        this.copyites.splice(index, 1);
                        this.convites.splice(index, 1);
            
                    });
                            
                    this.prepareLoop(this.copyites);

                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                });

    }

    conviteSave() {

        let erro = '';
        let array = this.convitePega(this.produtoID);
        let conviteMale = array[0];
        let conviteFema = array[1];
        
        if (conviteMale) {

            if (conviteMale.conviteSeta == TConviteSeta.csFree && !conviteMale.ConviteFree) {
                conviteMale.ConviteSeco = 0;
                conviteMale.ConviteSuma = 0;
                conviteMale.ConviteSuga = 0;
            }

            if (conviteMale.ConviteSeco == 0) {
                conviteMale.ConviteMeia = 0;
                conviteMale.ConviteObar = 0;
            }

            if (conviteMale.ConviteSeco > conviteMale.ConviteSuma) {
                conviteMale.ConviteSuma = 0;
                conviteMale.ConviteSuga = 0;
            }

            if (conviteMale.ConviteSeco + conviteMale.ConviteSuma == 0) {
                conviteMale.ConviteFree = false;
            }

            if (conviteMale.Produto.ProdutoLote == 0) {
                conviteMale.ConviteDoor = true;
                conviteMale.ConviteList = false;
                conviteMale.ConviteSale = false;
            }

            let enabled = (conviteMale.ConviteDoor || conviteMale.ConviteList || conviteMale.ConviteSale);
            let lotepayMale = conviteMale.ConviteSeco+conviteMale.ConviteSuma;
            if (!erro && !conviteMale.ConviteID && !enabled) erro = 'Selecione o tipo do lote';
            if (!erro && conviteMale.conviteSeta == TConviteSeta.csNone) erro = 'selecione a opção' + (this.entradaSexo ? ' do HOMEM' : '');
            if (!erro && conviteMale.conviteSeta > TConviteSeta.csFree && !lotepayMale) erro = 'selecione o FREE ou informe o VALOR';
            if (erro) {
                this.convitePage = (enabled ? 1 : 0);
                this.conviteSexo = conviteMale;
                this.util.toastSimply(erro);
                return
            }

        }

        if (conviteFema) {

            conviteFema.ConviteDoor = conviteMale.ConviteDoor;
            conviteFema.ConviteList = conviteMale.ConviteList;
            conviteFema.ConviteSale = conviteMale.ConviteSale;
            conviteFema.ConviteQtde = conviteMale.ConviteQtde;
            conviteFema.ConviteHora = conviteMale.ConviteHora;
            conviteFema.ConviteHour = conviteMale.ConviteHour;

            if (conviteFema.conviteSeta == TConviteSeta.csFree && !conviteFema.ConviteFree) {
                conviteFema.ConviteSeco = 0;
                conviteFema.ConviteSuma = 0;
                conviteFema.ConviteSuga = 0;
            }

            if (conviteFema.ConviteSeco == 0) {
                conviteFema.ConviteMeia = 0;
                conviteFema.ConviteObar = 0;
            }

            if (conviteFema.ConviteSeco > conviteFema.ConviteSuma) {
                conviteFema.ConviteSuma = 0;
                conviteFema.ConviteSuga = 0;
            }

            if (conviteFema.ConviteSeco + conviteFema.ConviteSuma == 0) {
                conviteFema.ConviteFree = false;
            }

            if (conviteFema.Produto.ProdutoLote == 0) {
                conviteFema.ConviteDoor = true;
                conviteFema.ConviteList = false;
                conviteFema.ConviteSale = false;
            }

            let enabled = (conviteFema.ConviteDoor || conviteFema.ConviteList || conviteFema.ConviteSale);
            let lotepayFema = conviteFema.ConviteSeco+conviteFema.ConviteSuma;
            if (!erro && !conviteFema.ConviteID && !enabled) erro = 'Selecione o tipo do lote';
            if (!erro && conviteFema.conviteSeta == TConviteSeta.csNone) erro = 'selecione a opção da MULHER';
            if (!erro && conviteFema.conviteSeta > TConviteSeta.csFree && !lotepayFema) erro = 'selecione o FREE ou informe o VALOR';
            if (erro) {
                this.convitePage = 2;
                this.conviteSexo = conviteFema;
                this.util.toastSimply(erro);
                return
            }

        }


        let spotdayID = (this.spotdayLoad ? this.spotdayLoad.SpotdayID : 0);
        let ambientID = this.recintos[this.entradaPage].Ambient.AmbientID;
        let conviteJson = {Convites: [conviteMale]};
        if (conviteFema) conviteJson.Convites.push(conviteFema);

        let loading = this.util.loadingDots();
        loading.present();

        this.entrakiService.convite(TAction.acSave, this.rootspot.Hotspots[0].HotspotID, spotdayID, ambientID, conviteJson)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (conviteMale && !conviteMale.ConviteID) conviteMale.ConviteID = data.Convites[0].Codigo;
                    if (conviteFema && !conviteFema.ConviteID) conviteFema.ConviteID = data.Convites[1].Codigo;
                                        
                    this.util.populateObj(this.convites, this.copyites);
                    this.dismiss();
            
                },
                erro => {

                    let closing = (erro.Action == '#CONVITE-LOAD#' ? erro.Action : null);
                    this.util.alertResult(erro, () => this.dismiss(closing));

                });

    }

    convitePlus() {

        if (this.conviteSexo.conviteSeta == TConviteSeta.csSeco) this.conviteSexo.ConviteSeco = this.conviteSexo.ConviteSeco + 1;
        if (this.conviteSexo.conviteSeta == TConviteSeta.csSuma && !this.conviteSexo.ConviteSuga) this.conviteSexo.ConviteSuma = this.conviteSexo.ConviteSuma + 1;
        if (this.conviteSexo.conviteSeta == TConviteSeta.csSuma &&  this.conviteSexo.ConviteSuga) this.conviteSexo.ConviteSuga = this.conviteSexo.ConviteSuga + 1;

    }

    dismiss(databack: any = null) {

        if (this.etapa == 1) {

            let array = this.copyites.filter(CV => CV.ConviteID == 0);
            array.forEach(CV => {

                let index = this.copyites.indexOf(CV);
                this.copyites.splice(index, 1);

            });

            this.util.populateObj(this.copyites, this.convites);

        }

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(databack);
        }

        if (!this.viewCtrl.isOverlay) {
            this.navCtrl.pop({animation: 'md-transition'});
        }

    }


}




// WEBPACK FOOTER //
// ./src/pages/sync/convite-menu/convite-menu.ts